<template>
  <div class="campaign-performance">
    <div class="py-4">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6">
              <div class="card p-3">
                <h6 class="text-muted text-center">EMAILS SENT</h6>
                <h2 class="fw-bold text-center">24,510</h2>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card p-3">
                <h6 class="text-muted text-center">OPEN RATE</h6>
                <h2 class="fw-bold text-center">19,500</h2>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card p-3">
                <h6 class="text-muted text-center">UNSUBSCRIBE RATE</h6>
                <h2 class="fw-bold text-center">3,920</h2>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card p-3">
                <h6 class="text-muted text-center">APPLICATIONS FROM EMAIL</h6>
                <h2 class="fw-bold text-center">11,140</h2>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card p-3">
                <h6 class="text-muted mb-2 text-uppercase">
                  Open and click rates by campaign
                </h6>
                <div>
                  <BasicBar
                    :data="openAndClickRatesData"
                    :height="400"
                    :options="options"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6">
              <div class="card p-3">
                <h6 class="text-muted text-center">CLICK THROUGH RATE</h6>
                <h2 class="fw-bold text-center">16,950</h2>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card p-3">
                <h6 class="text-muted text-center">BOUNCE RATE</h6>
                <h2 class="fw-bold text-center">2,700</h2>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card p-3">
                <h6 class="text-muted mb-2 text-uppercase">Heat Map</h6>
                <div>
                  <HeatMap />
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card p-3">
                <h6 class="text-muted mb-2 text-uppercase">
                  TOP PERFORMING SUBJECT LINES
                </h6>
                <div class="table-responsive w-100">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Subject Line</th>
                        <th scope="col">Month/Year</th>
                        <th scope="col">Conversion(%)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">1</th>
                        <td>Pediatric Nurse</td>
                        <td>Jun/2025</td>
                        <td>83</td>
                      </tr>
                      <tr>
                        <th scope="row">2</th>
                        <td>Pediatric Specialist</td>
                        <td>Feb/2025</td>
                        <td>77</td>
                      </tr>
                      <tr>
                        <th scope="row">3</th>
                        <td>Neurosurgeon</td>
                        <td>Sep/2025</td>
                        <td>73</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BasicBar from "@/components/reusable/Charts/BasicBar.vue";
import HeatMap from "@/components/reusable/Charts/Apex/HeatMap.vue";
export default {
  name: "Emails",
  components: {
    BasicBar,
    HeatMap,
  },
  data() {
    return {
      openAndClickRatesData: [
        {
          name: "Open Rate",
          borderColor: "#5478AF",
          backgroundColor: "#5478AF",
          values: [
            { name: "Campaign 1", value: 300 },
            { name: "Campaign 2", value: 220 },
            { name: "Campaign 3", value: 150 },
            { name: "Campaign 4", value: 250 },
            { name: "Campaign 5", value: 350 },
            { name: "Campaign 6", value: 450 },
          ],
        },
        {
          name: "Click Rate",
          borderColor: "#25436D",
          backgroundColor: "#25436D",
          values: [
            { name: "Campaign 1", value: 400 },
            { name: "Campaign 2", value: 200 },
            { name: "Campaign 3", value: 120 },
            { name: "Campaign 4", value: 350 },
            { name: "Campaign 5", value: 500 },
            { name: "Campaign 6", value: 400 },
          ],
        },
      ],
      funnelChartData: [
        {
          name: "Total Reach",
          value: 500,
        },
        {
          name: "Total Clicks",
          value: 400,
        },
        {
          name: "Total Applications Started",
          value: 350,
        },
        {
          name: "Total Applications Completed",
          value: 250,
        },
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        animation: {
          duration: 0,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                display: true,
                beginAtZero: true,
                fontStyle: "bold",
              },
              scaleLabel: {
                display: false,
                fontStyle: "bold",
              },
              gridLines: {
                display: true,
              },
              title: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                display: true,
                beginAtZero: true,
                fontStyle: "bold",
              },
              scaleLabel: {
                display: true,
                fontStyle: "bold",
              },
              gridLines: {
                display: true,
              },
              title: {
                display: false,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            color: "#fff",
            anchor: "end",
            align: "start",
            font: {
              weight: "bold",
              size: 12,
            },
            formatter: (value) => value,
          },
        },
      },
      campaignContributionData: [
        {
          name: "Total Reach",
          value: 500,
          backgroundColor: "#4971AB",
        },
        {
          name: "Total Clicks",
          value: 400,
          backgroundColor: "#25436D",
        },
      ],
      pieOptions: {
        maintainAspectRatio: false,
        animation: {
          duration: 0, // Disable all animations
        },
        legend: {
          display: false,
        },
      },
      defaultDatasets: [
        {
          backgroundColor: ["#25436D", "#4971AB"],
          data: [500, 400],
          label: "Total Reach",
          hoverOffset: 10,
        },
      ],
      labels: ["Total Reach", "Total Clicks"],
    };
  },
};
</script>
<style scoped>
.card {
  border: none;
  border-radius: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.funnel {
  background: linear-gradient(to bottom, #1e3a8a, #2563eb);
  border-radius: 16px;
  color: #ffffff;
  text-align: center;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
  min-height: 400px;
}

.funnel-step {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.4);
  margin: 0.5rem 0;
}
.chart-container {
  height: 200px;
}
.donut-chart {
  height: 250px;
}
</style>
